export default __webpack_public_path__ + "static/media/1872.91189e36.jpg";